import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const SectionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 20px 9px 20px;
  border-top: 1px solid ${colors.lightGray21};
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: end;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: end;
`;

export const PlaceholderContainer = styled.div`
  display: inline-flex;
  height: 26px;
  border-top: 1px solid ${colors.lightGray21};
  width: 100%;
  align-items: center;
`;

PlaceholderContainer.displayName = 'PlaceholderContainer';

export const PlaceholderText = styled.div`
  font-size: 11px;
  color: ${colors.lightGray2};
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  margin-left: 55px;
`;

PlaceholderText.displayName = 'PlaceholderText';

export const ConversationAttachmentsSectionBackToCurrent = styled.div`
  display: flex;
  cursor: pointer;
`;

export const ConversationAttachmentsButtonGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

ConversationAttachmentsButtonGrid.displayName = 'PreviousConversationGrid';

export const AttachmentLink = styled.a`
  outline: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  justify-content: center;
  width: 125px;
  height: 25px;
  border-radius: 3px;
  display: flex;
  margin-right: 7px;
  margin-top: 5px;
  cursor: pointer;
  align-items: center;
  background-color: ${colors.lightGray23};
  animation-direction: forwards;
  animation-name: fadeIn;
  animation-duration: 0.8s;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

AttachmentLink.displayName = 'PreviousConversationButton';

export const CloseContainer = styled.div`
  display: block;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 14px 00px 0px 0px;

  img {
    cursor: pointer;
  }
`;
